// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.background_vFIX0 {
  position : absolute;
  top : 0;
  bottom : 0;
  right : 0;
  left : 0;
}

.onlyClickMe_twcqE { 
  height : 100%;
  pointer-events: none !important;
}
.onlyClickMe_twcqE > * { 
  pointer-events: all;
}


.sidebar_jUlZq {
}

.sidebarLeft_Povj2 {
  position : absolute;
  top : 0;
  left : 0;
  bottom : 0;
}

.sidebarCenter_X5tTZ {
  position : absolute;
  top : 0;
  right : 0;
  bottom : 0;
  left : 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center
}

.sidebarFull_BwGyV {
  position : absolute;
  top : 0;
  right : 0;
  bottom : 0;
  left : 0;
}


.sidebarRight_duiaL {
  position : absolute;
  top : 0;
  right : 0;
  bottom : 0;
}

.sidebarTop_wtryd {
  position : absolute;
  top : 0;
  left : 0;
  right : 0;
}

.sidebarBottom_HQvDR {
  position : absolute;
  bottom : 0;
  left : 0;
  right : 0;
}

.fadeEnter_EI4lw {
  opacity: 0;
  -webkit-animation-fill-mode: forwards;
          animation-fill-mode: forwards;

}
.fadeEnterActive_MWoom {
  opacity: 1;
  -webkit-transition: opacity 300ms;
  transition: opacity 300ms;
}
.fadeExit_kCTOr {
  opacity: 1;
}
.fadeExitActive_hLg8P {
  opacity: 0;
  -webkit-transition: opacity 300ms;
  transition: opacity 300ms;
}



.slideFromRightEnter_voto1 {
  opacity: 0;
  -webkit-transform: translateX(100%);
          transform: translateX(100%);
}
.slideFromRightEnterActive_hLp1D {
  opacity: 1;
  -webkit-transform: translateX(0);
          transform: translateX(0);
  -webkit-transition: opacity 300ms, -webkit-transform 300ms;
  transition: opacity 300ms, -webkit-transform 300ms;
  transition: opacity 300ms, transform 300ms;
  transition: opacity 300ms, transform 300ms, -webkit-transform 300ms;
}
.slideFromRightExit_f30Un {
  opacity: 1;
}
.slideFromRightExitActive_XBxmG {
  -webkit-transform: translateX(100%);
          transform: translateX(100%);
  opacity: 0;
  -webkit-transition: opacity 300ms, -webkit-transform 300ms;
  transition: opacity 300ms, -webkit-transform 300ms;
  transition: opacity 300ms, transform 300ms;
  transition: opacity 300ms, transform 300ms, -webkit-transform 300ms;
}


.slideFromLeftEnter_acYmu {
  opacity: 0;
  -webkit-transform: translateX(-100%);
          transform: translateX(-100%);
}
.slideFromLeftEnterActive_MlMMP {
  opacity: 1;
  -webkit-transform: translateX(0);
          transform: translateX(0);
  -webkit-transition: opacity 300ms, -webkit-transform 300ms;
  transition: opacity 300ms, -webkit-transform 300ms;
  transition: opacity 300ms, transform 300ms;
  transition: opacity 300ms, transform 300ms, -webkit-transform 300ms;
}
.slideFromLeftExit_xtu93 {
  opacity: 1;
}
.slideFromLeftExitActive_ZABxz {
  -webkit-transform: translateX(-100%);
          transform: translateX(-100%);
  opacity: 0;
  -webkit-transition: opacity 300ms, -webkit-transform 300ms;
  transition: opacity 300ms, -webkit-transform 300ms;
  transition: opacity 300ms, transform 300ms;
  transition: opacity 300ms, transform 300ms, -webkit-transform 300ms;
}


.slideFromBottomEnter_Z3n14 {
  opacity: 0;
  -webkit-transform: translateY(100%);
          transform: translateY(100%);
}
.slideFromBottomEnterActive_jP7qi {
  opacity: 1;
  -webkit-transform: translateY(0);
          transform: translateY(0);
  -webkit-transition: opacity 300ms, -webkit-transform 300ms;
  transition: opacity 300ms, -webkit-transform 300ms;
  transition: opacity 300ms, transform 300ms;
  transition: opacity 300ms, transform 300ms, -webkit-transform 300ms;
}
.slideFromBottomExit_M6fce {
  opacity: 1;
}
.slideFromBottomExitActive_GdnwY {
  -webkit-transform: translateY(100%);
          transform: translateY(100%);
  opacity: 0;
  -webkit-transition: opacity 300ms, -webkit-transform 300ms;
  transition: opacity 300ms, -webkit-transform 300ms;
  transition: opacity 300ms, transform 300ms;
  transition: opacity 300ms, transform 300ms, -webkit-transform 300ms;
}


.slideFromTopEnter__86VZ {
  opacity: 0;
  -webkit-transform: translateY(-100%);
          transform: translateY(-100%);
}
.slideFromTopEnterActive_G_aaH {
  opacity: 1;
  -webkit-transform: translateY(0);
          transform: translateY(0);
  -webkit-transition: opacity 300ms, -webkit-transform 300ms;
  transition: opacity 300ms, -webkit-transform 300ms;
  transition: opacity 300ms, transform 300ms;
  transition: opacity 300ms, transform 300ms, -webkit-transform 300ms;
}
.slideFromTopExit_j5tP8 {
  opacity: 1;
}
.slideFromTopExitActive_X3y9R {
  -webkit-transform: translateY(-100%);
          transform: translateY(-100%);
  opacity: 0;
  -webkit-transition: opacity 300ms, -webkit-transform 300ms;
  transition: opacity 300ms, -webkit-transform 300ms;
  transition: opacity 300ms, transform 300ms;
  transition: opacity 300ms, transform 300ms, -webkit-transform 300ms;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-elements/lib/esm/PortalOverlay.css"],"names":[],"mappings":";AACA;EACE,mBAAmB;EACnB,OAAO;EACP,UAAU;EACV,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;AACA;EACE,mBAAmB;AACrB;;;AAGA;AACA;;AAEA;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,OAAO;EACP,SAAS;EACT,UAAU;EACV,QAAQ;EACR,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAsB;MAAtB,qBAAsB;UAAtB;AACF;;AAEA;EACE,mBAAmB;EACnB,OAAO;EACP,SAAS;EACT,UAAU;EACV,QAAQ;AACV;;;AAGA;EACE,mBAAmB;EACnB,OAAO;EACP,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,UAAU;EACV,qCAA6B;UAA7B,6BAA6B;;AAE/B;AACA;EACE,UAAU;EACV,iCAAyB;EAAzB,yBAAyB;AAC3B;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,iCAAyB;EAAzB,yBAAyB;AAC3B;;;;AAIA;EACE,UAAU;EACV,mCAA2B;UAA3B,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,gCAAwB;UAAxB,wBAAwB;EACxB,0DAA0C;EAA1C,kDAA0C;EAA1C,0CAA0C;EAA1C,mEAA0C;AAC5C;AACA;EACE,UAAU;AACZ;AACA;EACE,mCAA2B;UAA3B,2BAA2B;EAC3B,UAAU;EACV,0DAA0C;EAA1C,kDAA0C;EAA1C,0CAA0C;EAA1C,mEAA0C;AAC5C;;;AAGA;EACE,UAAU;EACV,oCAA4B;UAA5B,4BAA4B;AAC9B;AACA;EACE,UAAU;EACV,gCAAwB;UAAxB,wBAAwB;EACxB,0DAA0C;EAA1C,kDAA0C;EAA1C,0CAA0C;EAA1C,mEAA0C;AAC5C;AACA;EACE,UAAU;AACZ;AACA;EACE,oCAA4B;UAA5B,4BAA4B;EAC5B,UAAU;EACV,0DAA0C;EAA1C,kDAA0C;EAA1C,0CAA0C;EAA1C,mEAA0C;AAC5C;;;AAGA;EACE,UAAU;EACV,mCAA2B;UAA3B,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,gCAAwB;UAAxB,wBAAwB;EACxB,0DAA0C;EAA1C,kDAA0C;EAA1C,0CAA0C;EAA1C,mEAA0C;AAC5C;AACA;EACE,UAAU;AACZ;AACA;EACE,mCAA2B;UAA3B,2BAA2B;EAC3B,UAAU;EACV,0DAA0C;EAA1C,kDAA0C;EAA1C,0CAA0C;EAA1C,mEAA0C;AAC5C;;;AAGA;EACE,UAAU;EACV,oCAA4B;UAA5B,4BAA4B;AAC9B;AACA;EACE,UAAU;EACV,gCAAwB;UAAxB,wBAAwB;EACxB,0DAA0C;EAA1C,kDAA0C;EAA1C,0CAA0C;EAA1C,mEAA0C;AAC5C;AACA;EACE,UAAU;AACZ;AACA;EACE,oCAA4B;UAA5B,4BAA4B;EAC5B,UAAU;EACV,0DAA0C;EAA1C,kDAA0C;EAA1C,0CAA0C;EAA1C,mEAA0C;AAC5C","sourcesContent":["\n.background {\n  position : absolute;\n  top : 0;\n  bottom : 0;\n  right : 0;\n  left : 0;\n}\n\n.onlyClickMe { \n  height : 100%;\n  pointer-events: none !important;\n}\n.onlyClickMe > * { \n  pointer-events: all;\n}\n\n\n.sidebar {\n}\n\n.sidebarLeft {\n  position : absolute;\n  top : 0;\n  left : 0;\n  bottom : 0;\n}\n\n.sidebarCenter {\n  position : absolute;\n  top : 0;\n  right : 0;\n  bottom : 0;\n  left : 0;\n  display: flex;\n  align-items: center;\n  justify-content: center\n}\n\n.sidebarFull {\n  position : absolute;\n  top : 0;\n  right : 0;\n  bottom : 0;\n  left : 0;\n}\n\n\n.sidebarRight {\n  position : absolute;\n  top : 0;\n  right : 0;\n  bottom : 0;\n}\n\n.sidebarTop {\n  position : absolute;\n  top : 0;\n  left : 0;\n  right : 0;\n}\n\n.sidebarBottom {\n  position : absolute;\n  bottom : 0;\n  left : 0;\n  right : 0;\n}\n\n.fadeEnter {\n  opacity: 0;\n  animation-fill-mode: forwards;\n\n}\n.fadeEnterActive {\n  opacity: 1;\n  transition: opacity 300ms;\n}\n.fadeExit {\n  opacity: 1;\n}\n.fadeExitActive {\n  opacity: 0;\n  transition: opacity 300ms;\n}\n\n\n\n.slideFromRightEnter {\n  opacity: 0;\n  transform: translateX(100%);\n}\n.slideFromRightEnterActive {\n  opacity: 1;\n  transform: translateX(0);\n  transition: opacity 300ms, transform 300ms;\n}\n.slideFromRightExit {\n  opacity: 1;\n}\n.slideFromRightExitActive {\n  transform: translateX(100%);\n  opacity: 0;\n  transition: opacity 300ms, transform 300ms;\n}\n\n\n.slideFromLeftEnter {\n  opacity: 0;\n  transform: translateX(-100%);\n}\n.slideFromLeftEnterActive {\n  opacity: 1;\n  transform: translateX(0);\n  transition: opacity 300ms, transform 300ms;\n}\n.slideFromLeftExit {\n  opacity: 1;\n}\n.slideFromLeftExitActive {\n  transform: translateX(-100%);\n  opacity: 0;\n  transition: opacity 300ms, transform 300ms;\n}\n\n\n.slideFromBottomEnter {\n  opacity: 0;\n  transform: translateY(100%);\n}\n.slideFromBottomEnterActive {\n  opacity: 1;\n  transform: translateY(0);\n  transition: opacity 300ms, transform 300ms;\n}\n.slideFromBottomExit {\n  opacity: 1;\n}\n.slideFromBottomExitActive {\n  transform: translateY(100%);\n  opacity: 0;\n  transition: opacity 300ms, transform 300ms;\n}\n\n\n.slideFromTopEnter {\n  opacity: 0;\n  transform: translateY(-100%);\n}\n.slideFromTopEnterActive {\n  opacity: 1;\n  transform: translateY(0);\n  transition: opacity 300ms, transform 300ms;\n}\n.slideFromTopExit {\n  opacity: 1;\n}\n.slideFromTopExitActive {\n  transform: translateY(-100%);\n  opacity: 0;\n  transition: opacity 300ms, transform 300ms;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"background": `background_vFIX0`,
	"onlyClickMe": `onlyClickMe_twcqE`,
	"sidebar": `sidebar_jUlZq`,
	"sidebarLeft": `sidebarLeft_Povj2`,
	"sidebarCenter": `sidebarCenter_X5tTZ`,
	"sidebarFull": `sidebarFull_BwGyV`,
	"sidebarRight": `sidebarRight_duiaL`,
	"sidebarTop": `sidebarTop_wtryd`,
	"sidebarBottom": `sidebarBottom_HQvDR`,
	"fadeEnter": `fadeEnter_EI4lw`,
	"fadeEnterActive": `fadeEnterActive_MWoom`,
	"fadeExit": `fadeExit_kCTOr`,
	"fadeExitActive": `fadeExitActive_hLg8P`,
	"slideFromRightEnter": `slideFromRightEnter_voto1`,
	"slideFromRightEnterActive": `slideFromRightEnterActive_hLp1D`,
	"slideFromRightExit": `slideFromRightExit_f30Un`,
	"slideFromRightExitActive": `slideFromRightExitActive_XBxmG`,
	"slideFromLeftEnter": `slideFromLeftEnter_acYmu`,
	"slideFromLeftEnterActive": `slideFromLeftEnterActive_MlMMP`,
	"slideFromLeftExit": `slideFromLeftExit_xtu93`,
	"slideFromLeftExitActive": `slideFromLeftExitActive_ZABxz`,
	"slideFromBottomEnter": `slideFromBottomEnter_Z3n14`,
	"slideFromBottomEnterActive": `slideFromBottomEnterActive_jP7qi`,
	"slideFromBottomExit": `slideFromBottomExit_M6fce`,
	"slideFromBottomExitActive": `slideFromBottomExitActive_GdnwY`,
	"slideFromTopEnter": `slideFromTopEnter__86VZ`,
	"slideFromTopEnterActive": `slideFromTopEnterActive_G_aaH`,
	"slideFromTopExit": `slideFromTopExit_j5tP8`,
	"slideFromTopExitActive": `slideFromTopExitActive_X3y9R`
};
export default ___CSS_LOADER_EXPORT___;
